<template>
<v-app>
  <body class="bg-purple">
    <img
      class="hidden-xs-only maintaintext"
      src="/img/maintenance/maintainText.svg"
      style="max-width: 1000px; margin: auto;"
    >
    <img
      class="hidden-sm-and-up maintaintext"
      src="/img/maintenance/maintainTextmd.svg"
      style="max-width: 600px; margin: auto 20px;"
    >
    <div class="stars">
      <div class="central-body"></div>
      <div class="objects">
        <div class="earth-moon">
          <img class="object_earth" src="/img/maintenance/earth.svg" width="100px">
          <img class="object_moon" src="/img/maintenance/moon.svg" width="80px">
        </div>
      </div>
      <div class="glowing_stars">
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
      </div>
    </div>
  </body>
  <article id="wrap">
    <article id="lightings">
      <section id="ARone">
        <section id="ARtwo">
          <section id="ARthree">
            <section id="ARfour">
              <section id="ARfive"></section>
            </section>
          </section>
        </section>
      </section>
    </article>
  </article>
</v-app>
</template>

<script>
export default {
  components: {},
  data: () => ({}),
  mounted() {}
};
</script>

<style>
#core-view {
  padding-bottom: 0px !important;
}

#wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  margin: 0 auto 0 auto;
  overflow: hidden;
}

#lightings {
  bottom: -60px;
  position: absolute;
  width: 100%;
}

.maintaintext {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

section {
  /*border-radius*/
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  height: 20px;
  width: 100%;
  position: relative;
  margin: auto;
}

#ARone {
  /*animation*/
  -webkit-animation: ARone 5s ease-in-out infinite alternate;
  -moz-animation: ARone 5s ease-in-out infinite alternate;
  -ms-animation: ARone 5s ease-in-out infinite alternate;
  -o-animation: ARone 5s ease-in-out infinite alternate;
  animation: ARone 5s ease-in-out infinite alternate;
}
@-webkit-keyframes ARone {
  from {
    -webkit-box-shadow: 0 0 250px 20px #473c78;
  }

  to {
    -webkit-box-shadow: 0 0 100px 15px #f72a3b;
  }
}
@-moz-keyframes ARone {
  from {
    -moz-box-shadow: 0 0 250px 20px #473c78;
  }

  to {
    -moz-box-shadow: 0 0 100px 15px #f72a3b;
  }
}
@-o-keyframes ARone {
  from {
    -o-box-shadow: 0 0 250px 20px #473c78;
  }

  to {
    -o-box-shadow: 0 0 100px 15px #f72a3b;
  }
}

@keyframes ARone {
  from {
    box-shadow: 0 0 250px 20px #473c78;
  }

  to {
    box-shadow: 0 0 100px 15px #f72a3b;
  }
}

#ARtwo {
  width: 90%;
  /*animation*/
  -webkit-animation: ARtwo 4s ease-in-out infinite alternate;
  -moz-animation: ARtwo 4s ease-in-out infinite alternate;
  -ms-animation: ARtwo 4s ease-in-out infinite alternate;
  -o-animation: ARtwo 4s ease-in-out infinite alternate;
  animation: ARtwo 4s ease-in-out infinite alternate;
}
@-webkit-keyframes ARtwo {
  from {
    -webkit-box-shadow: 0 0 250px 20px #18c499;
  }

  to {
    -webkit-box-shadow: 0 0 100px 15px #d8f05e;
  }
}
@-moz-keyframes ARtwo {
  from {
    -moz-box-shadow: 0 0 250px 20px #18c499;
  }

  to {
    -moz-box-shadow: 0 0 100px 15px #d8f05e;
  }
}
@-o-keyframes ARtwo {
  from {
    -o-box-shadow: 0 0 250px 20px #18c499;
  }

  to {
    -o-box-shadow: 0 0 100px 15px #d8f05e;
  }
}

@keyframes ARtwo {
  from {
    box-shadow: 0 0 250px 20px #18c499;
  }

  to {
    box-shadow: 0 0 100px 15px #d8f05e;
  }
}

#ARthree {
  width: 80%;
  /*animation*/
  -webkit-animation: ARthree 3s ease-in-out infinite alternate;
  -moz-animation: ARthree 3s ease-in-out infinite alternate;
  -ms-animation: ARthree 3s ease-in-out infinite alternate;
  -o-animation: ARthree 3s ease-in-out infinite alternate;
  animation: ARthree 3s ease-in-out infinite alternate;
}
@-webkit-keyframes ARthree {
  from {
    -webkit-box-shadow: 0 0 250px 20px #ffdd00;
  }

  to {
    -webkit-box-shadow: 0 0 100px 15px #3e33ff;
  }
}
@-moz-keyframes ARthree {
  from {
    -moz-box-shadow: 0 0 250px 20px #ffdd00;
  }

  to {
    -moz-box-shadow: 0 0 100px 15px #3e33ff;
  }
}
@-o-keyframes ARthree {
  from {
    -o-box-shadow: 0 0 250px 20px #ffdd00;
  }

  to {
    -o-box-shadow: 0 0 100px 15px #3e33ff;
  }
}

@keyframes ARthree {
  from {
    box-shadow: 0 0 250px 20px #ffdd00;
  }

  to {
    box-shadow: 0 0 100px 15px #3e33ff;
  }
}

#ARfour {
  width: 70%;
  /*animation*/
  -webkit-animation: ARfour 2s ease-in-out infinite alternate;
  -moz-animation: ARfour 2s ease-in-out infinite alternate;
  -ms-animation: ARfour 2s ease-in-out infinite alternate;
  -o-animation: ARfour 2s ease-in-out infinite alternate;
  animation: ARfour 2s ease-in-out infinite alternate;
}
@-webkit-keyframes ARfour {
  from {
    -webkit-box-shadow: 0 0 250px 20px #781848;
  }

  to {
    -webkit-box-shadow: 0 0 100px 15px #f2bbe9;
  }
}
@-moz-keyframes ARfour {
  from {
    -moz-box-shadow: 0 0 250px 20px #781848;
  }

  to {
    -moz-box-shadow: 0 0 100px 15px #f2bbe9;
  }
}
@-o-keyframes ARfour {
  from {
    -o-box-shadow: 0 0 250px 20px #781848;
  }

  to {
    -o-box-shadow: 0 0 100px 15px #f2bbe9;
  }
}

@keyframes ARfour {
  from {
    shadow: 0 0 250px 20px #781848;
  }

  to {
    shadow: 0 0 100px 15px #f2bbe9;
  }
}

#ARfive {
  width: 60%;
  /*animation*/
  -webkit-animation: ARfive 1s ease-in-out infinite alternate;
  -moz-animation: ARfive 1s ease-in-out infinite alternate;
  -ms-animation: ARfive 1s ease-in-out infinite alternate;
  -o-animation: ARfive 1s ease-in-out infinite alternate;
  animation: ARfive 1s ease-in-out infinite alternate;
}
@-webkit-keyframes ARfive {
  from {
    -webkit-box-shadow: 0 0 250px 20px #42f2a1;
  }

  to {
    -webkit-box-shadow: 0 0 100px 15px #f4f6ad;
  }
}
@-moz-keyframes ARfive {
  from {
    -moz-box-shadow: 0 0 250px 20px #42f2a1;
  }

  to {
    -moz-box-shadow: 0 0 100px 15px #f4f6ad;
  }
}
@-o-keyframes ARfive {
  from {
    -o-box-shadow: 0 0 250px 20px #42f2a1;
  }

  to {
    -o-box-shadow: 0 0 100px 15px #f4f6ad;
  }
}

@keyframes ARfive {
  from {
    box-shadow: 0 0 250px 20px #42f2a1;
  }

  to {
    box-shadow: 0 0 100px 15px #f4f6ad;
  }
}

@-moz-keyframes rocket-movement {
  100% {
    -moz-transform: translate(1200px, -600px);
  }
}
@-webkit-keyframes rocket-movement {
  100% {
    -webkit-transform: translate(1200px, -600px);
  }
}
@keyframes rocket-movement {
  100% {
    transform: translate(1200px, -600px);
  }
}
@-moz-keyframes spin-earth {
  100% {
    -moz-transform: rotate(-360deg);
    transition: transform 20s;
  }
}
@-webkit-keyframes spin-earth {
  100% {
    -webkit-transform: rotate(-360deg);
    transition: transform 20s;
  }
}
@keyframes spin-earth {
  100% {
    -webkit-transform: rotate(-360deg);
    transform: rotate(-360deg);
    transition: transform 20s;
  }
}

@-moz-keyframes move-astronaut {
  100% {
    -moz-transform: translate(-160px, -160px);
  }
}
@-webkit-keyframes move-astronaut {
  100% {
    -webkit-transform: translate(-160px, -160px);
  }
}
@keyframes move-astronaut {
  100% {
    -webkit-transform: translate(-160px, -160px);
    transform: translate(-160px, -160px);
  }
}
@-moz-keyframes rotate-astronaut {
  100% {
    -moz-transform: rotate(-720deg);
  }
}
@-webkit-keyframes rotate-astronaut {
  100% {
    -webkit-transform: rotate(-720deg);
  }
}
@keyframes rotate-astronaut {
  100% {
    -webkit-transform: rotate(-720deg);
    transform: rotate(-720deg);
  }
}

@-moz-keyframes glow-star {
  40% {
    -moz-opacity: 0.3;
  }
  90%,
  100% {
    -moz-opacity: 1;
    -moz-transform: scale(1.2);
  }
}
@-webkit-keyframes glow-star {
  40% {
    -webkit-opacity: 0.3;
  }
  90%,
  100% {
    -webkit-opacity: 1;
    -webkit-transform: scale(1.2);
  }
}
@keyframes glow-star {
  40% {
    -webkit-opacity: 0.3;
    opacity: 0.3;
  }
  90%,
  100% {
    -webkit-opacity: 1;
    opacity: 1;
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
    border-radius: 999999px;
  }
}

.spin-earth-on-hover {
  transition: ease 200s !important;
  transform: rotate(-3600deg) !important;
}

.bg-purple {
  background: url("/img/maintenance/darkbluebg.jpg");
  background-repeat: repeat-x;
  background-size: cover;
  background-position: left top;
  height: 100%;
  overflow: hidden;
}

.central-body {
  /*    width: 100%;*/
  padding: 17% 5% 10% 5%;
  text-align: center;
}

.objects img {
  z-index: 90;
  pointer-events: none;
}

.object_rocket {
  z-index: 95;
  position: absolute;
  transform: translateX(-50px);
  top: 75%;
  pointer-events: none;
  animation: rocket-movement 200s linear infinite both running;
}

.object_earth {
  position: absolute;
  top: 20%;
  left: 15%;
  z-index: 90;
  /*    animation: spin-earth 100s infinite linear both;*/
}

.object_moon {
  position: absolute;
  top: 12%;
  left: 25%;
  /*
    transform: rotate(0deg);
    transition: transform ease-in 99999999999s;
*/
}

.earth-moon {
}

.stars {
  background: url("/img/maintenance/overlaystars.svg");
  background-repeat: repeat;
  background-size: contain;
  background-position: left top;
}

.glowing_stars .star {
  position: absolute;
  border-radius: 100%;
  background-color: #fff;
  width: 3px;
  height: 3px;
  opacity: 0.3;
  will-change: opacity;
}

.glowing_stars .star:nth-child(1) {
  top: 80%;
  left: 25%;
  animation: glow-star 2s infinite ease-in-out alternate 1s;
}
.glowing_stars .star:nth-child(2) {
  top: 20%;
  left: 40%;
  animation: glow-star 2s infinite ease-in-out alternate 3s;
}
.glowing_stars .star:nth-child(3) {
  top: 25%;
  left: 25%;
  animation: glow-star 2s infinite ease-in-out alternate 5s;
}
.glowing_stars .star:nth-child(4) {
  top: 75%;
  left: 80%;
  animation: glow-star 2s infinite ease-in-out alternate 7s;
}
.glowing_stars .star:nth-child(5) {
  top: 90%;
  left: 50%;
  animation: glow-star 2s infinite ease-in-out alternate 9s;
}

@media only screen and (max-width: 600px) {
  .central-body {
    padding-top: 25%;
  }
}
</style>
